<template lang="pug">
.fake-data-container
  .fake-data-overlay
  .getting-started-dialog
    a.close(
      data-testid="close-fake-data-overlay"
      @click="close"
    )
      i.hi.hi-close.hi-12

    p.alert.alert-basic.header
      i.hi.hi-important.hi-16.mr-5
      | Your team has not tracked any time.

    h4 Getting started
    ol
      li Each team member needs to open their invite email and click the accept link.
      li
        | Next they must&nbsp;
        a(
          :href="downloadUrl"
          target="_blank"
          rel="noopener noreferrer"
        )
          | download the app.
      li Finally they have to install the app and use it to track time to a project.

    .fake-data-organizations
      h4 Your Organizations

      ActivitiesTeamStatus(
        v-for="organization in organizations"
        :key="organization.id"
        :org-id="organization.id"
        :org-name="organization.name"
      )

    .hint
      i.hi.hi-info.hi-16
      |
      | Time can also be added manually on the timesheets page.
</template>

<script>
import { mapState } from 'vuex';
import ActivitiesTeamStatus from './ActivitiesTeamStatus.vue';

export default {
  name: 'ActivitiesFakeTeamDataOverlay',
  components: {
    ActivitiesTeamStatus,
  },
  computed: {
    ...mapState({
      organizations: (state) => state.managed_organizations,
      downloadUrl: (state) => state.download_url,
    }),
  },
  methods: {
    close() {
      this.$emit('closeTeam');
    },
  },
};
</script>
